import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import {
  createDefaultSearchOrderResultData,
  ISearchOrderResultData,
} from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';
import {
  createDefaultSearchOrderSpecification,
  ISearchOrdersSpecificationData,
} from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export interface IOrderSearchState {
  searchResult: ISearchOrderResultData;
  searchSettings: ISearchOrdersSpecificationData;
  searchResultFetchStatus: IFetchStatus;
  searchResultError: string | null;
}

export const orderSearchInitialState: IOrderSearchState = {
  searchResult: createDefaultSearchOrderResultData(),
  searchSettings: createDefaultSearchOrderSpecification(),
  searchResultFetchStatus: createDefaultFetch(),
  searchResultError: null,
};
